import { useEffect, type ReactElement } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useAppSummaryDetailsQuery } from '~/queries/applications'
import { appKeyDeviceTypeToString } from '~/utils/application'

interface Props {
  service: 'application' | 'services'
}

// NOTE: this router is necessary to make intranet v2 backward compatible with intranet v3
const RedirectRouter = ({ service }: Props): ReactElement => {
  const params = useParams<{ appId: string }>()

  const location = useLocation()

  const navigate = useNavigate()

  const { data: application } = useAppSummaryDetailsQuery(params.appId, !!params.appId)

  useEffect(() => {
    if (service === 'application' && application) {
      const redirectPath = location.pathname.split('/').slice(3).join('/')
      navigate(`/${redirectPath}?app=${appKeyDeviceTypeToString(application.app_key, application.device_type)}`)
    } else if (service === 'services') {
      const redirectPath = location.pathname.split('/').slice(2).join('/')
      navigate(`/${redirectPath}`)
    }
  }, [service, application, location.pathname, navigate])

  return <div />
}

export default RedirectRouter
